<div>
    <div>Select Multiple Organizations</div>
    <div class="bottom-20">
        <Label for="Organization">Organization</Label>
        <jq-org-dropdown-multiselect (onValueChange)="OnOrgSelected($event)"></jq-org-dropdown-multiselect>
    </div>

    <div>
        <div>
            <button class="button primary" (click)="doSomethingWithOrgIds()">Get Reports</button>
        </div>
    </div>

</div>
